export default __webpack_public_path__ + "static/media/s-8.cbb5f2b9.jpg";